<div class="ui-doc-panel">
  <header class="ui-doc-panel__header">
    <div class="ui-doc-panel__header-left">
      <p class="ui-doc-panel__breadcrumb" *ngIf="breadcrumb">{{ breadcrumb }}</p>
      <div class="ui-doc-panel__title-row">
        <h2 class="ui-doc-panel__title">{{ title }}</h2>
        <app-ui-badge
          *ngIf="statusLabel"
          [label]="statusLabel"
          [variant]="statusVariant"
          [showDot]="true">
        </app-ui-badge>
      </div>
      <p class="ui-doc-panel__id" *ngIf="documentId">ID: {{ documentId }}</p>
    </div>
    <button
      *ngIf="showClose"
      type="button"
      class="ui-doc-panel__close"
      aria-label="Close"
      (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="ui-doc-panel__body">
    <ng-content></ng-content>
  </div>
  <div class="ui-doc-panel__footer">
    <ng-content select="app-ui-document-panel-footer"></ng-content>
  </div>
</div>
